
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { StepperComponent } from '../../blocks';
import { UserSessionService, PatientParms } from '../../shared';
//services
import { FamilyDetail, FamilyDetailService } from './family-detail.service';
import { ModalService } from '../../blocks';

import { takeUntil } from 'rxjs/operators'; import { Subject } from 'rxjs';
@Component({
    selector: 'family-detail',
    templateUrl: './family-detail.component.html'
})

export class FamilyDetailComponent implements OnInit, OnDestroy {
    private ngUnsubscribe: Subject<void> = new Subject<void>();
    myStepNumber: number = 2121;
    @Input() stepperComponent: StepperComponent;

    patientParms: PatientParms = <PatientParms>{};

    familyDetail: FamilyDetail[] = [];
    constructor(
        private _familyDetailService: FamilyDetailService,
        private _route: ActivatedRoute,
        private _location: Location,
        public translate: TranslateService,
        private _userSessionService: UserSessionService,
private _modalService: ModalService
        ) { }

    ngOnInit() {
        let inputsObj = this._userSessionService.getModalKey('FamilyDetailComponent');

        if (inputsObj && inputsObj["inputs"]) {
            let inputs = inputsObj["inputs"];
            this.patientParms.patCode = inputs['code'];
            this.getInputsAsPopub$();
        }
        else {
            //let _patientForEdit = this._userSessionService.subscribeToKey$('patientForEdit');
            this._userSessionService.subscribeToKey$('patientForEdit').pipe(
                takeUntil(this.ngUnsubscribe))
                .subscribe((keys: any) => {
                    if (keys && keys.value) {
                        let _patientForEdit = keys.value;
                        if (_patientForEdit) {
                            this.patientParms.patCode = _patientForEdit['code'];
                        }
                        this.myStepper$();
                        this.getInputsAsStep$();
                        this.getFamilyDetail();
                    }
                });
        }

        this.getFamilyDetail();



        ///gouhar
        this._userSessionService
            .subscribeToKey$('patientForEdit').pipe(
                takeUntil(this.ngUnsubscribe))
            .subscribe((keys: any) => {
                if (keys && keys.name == 'patientForEdit') {
                    if (keys.value && keys.value) {
                        this.patientParms.patCode = keys.value['code'];//this._userSessionService.getSessionKey('relativeParent')
                        this.getFamilyDetail();
                    }
                }
            });
    }

    getFamilyDetail() {
        let id = this.patientParms.patCode;
        if (id > 0 ) {
            this._familyDetailService.getfamilyDetail(id).subscribe(
                res => {  this.familyDetail = res.data
                
                }
            );
        }
    }

   
    

    goBack(): void {
        this._location.back();
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    //-----observable on step on wizard
    myStepper$() {
        if (this.stepperComponent) {
            this.stepperComponent.getCurrentStep().pipe(
                takeUntil(this.ngUnsubscribe))
                .subscribe((step: any) => {
                    if (step && step.serial == this.myStepNumber) {
                        this.getFamilyDetail();
                    }

                })
        }
    }
    //-----observable if it popuped
    getInputsAsPopub$() {
        this._userSessionService.getModalKey$().pipe(
            takeUntil(this.ngUnsubscribe))
            .subscribe((keys: any) => {
                if (keys.name == 'FamilyDetailComponent' && keys.inputs) {
                    this.patientParms.patCode = keys.inputs['code'];
                    this.getFamilyDetail();
                }
            });
    }
    //-----observable if it popuped
    getInputsAsStep$() {
        this._userSessionService.getSessionKey$('patientForEdit')
            .subscribe((keys: any) => {
                if (keys && keys.name == 'patientForEdit' && keys.value["code"]) {
                    this.patientParms.patCode = keys.value["code"];
                }
            });
    }


    deleteFamilyDetail(familyDetail:any){
        this._modalService.activeDelMes(familyDetail.fullnameAr, familyDetail.relativeNameAr).then(responseOK => {
            if (responseOK) {
                
              this._familyDetailService.deleteFamilyDetail(familyDetail.serial)
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(c => {
              }, error => console.log(error),
              
                () => this.getFamilyDetail( ));
        
            }
      
            
          });
       
        }




    onRowIconClick(actionCode: number,sal:FamilyDetail ) {
        
    
        this.deleteFamilyDetail(sal)
    

  }
}
